import React, { useEffect, useState, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SRow, SCol, SContainer } from '@avalara/skylab-sdk/react';
import CartInfo from './cart-info';
import RiskAssessmentBanner from './risk-banner';
import { accordionContent } from './constants';
import { StyledContainer } from '../styled/container';
import AccountAndPaymentAccordions from './account-payment-accordions';
import AccordionRoot from '../shared/accordion-root';
import { getLoginFromUrl, getMarketingDataFromUrl, getConnectors } from '../../lib/side-effects';
import { getRiskAssessmentSalestax } from '../../lib/side-effects/avatax';
import { validateDiscountCode } from '../../lib/side-effects/offers';
import { updateProductAnalytics } from '../../lib/side-effects/analytics';
import { setActiveFlow } from '../../store/system';
import { setDiscountCode } from '../../store/order';
import { selectState } from '../../selectors';
import ExternalLink from '../external-link';
import { useAbandonedCart } from '../shared/hooks';
const RiskAssessment = () => {
    const { account: { isLoggedIn }, order: { discountPercent }, } = useSelector(selectState);
    const dispatch = useDispatch();
    const searchParams = new URLSearchParams(window.location.search);
    const [discountCode] = useState(searchParams.get('c'));
    const [createAccountOpen, setCreateAccountOpen] = useState(true);
    const [sentPurchaseInfo, setSentPurchaseInfo] = useState(false);
    const [showConnectors, setShowConnectors] = useState(false);
    useState(getLoginFromUrl());
    useAbandonedCart();
    const onAccountOrPaymentAccordionToggle = () => {
        if (createAccountOpen && !isLoggedIn) {
            dispatch(getRiskAssessmentSalestax());
        }
        if (!sentPurchaseInfo) {
            dispatch(updateProductAnalytics('purchase_start'));
            setSentPurchaseInfo(true);
        }
    };
    const riskAssessmentFlow = isLoggedIn ? 'risk-assessment' : 'risk-assessment-net-new';
    useEffect(() => {
        dispatch(setActiveFlow(riskAssessmentFlow));
        if (discountCode != null) {
            dispatch(setDiscountCode(discountCode));
            dispatch(validateDiscountCode(riskAssessmentFlow, discountCode));
        }
        if (!isLoggedIn && discountPercent === 100) {
            setShowConnectors(true);
            dispatch(getConnectors());
        }
        if (isLoggedIn) {
            setCreateAccountOpen(false);
            setShowConnectors(false);
        }
    }, [isLoggedIn, discountPercent]);
    useEffect(() => {
        dispatch(getMarketingDataFromUrl());
    }, []);
    const GUIDED_QUESTIONNAIRE_ACCORDION_ITEM_INDEX = 0;
    return (React.createElement(Fragment, null,
        React.createElement(RiskAssessmentBanner, { role: 'complementary' }),
        React.createElement(StyledContainer, { role: 'main' },
            React.createElement(SContainer, { className: 'justify-content-center' },
                React.createElement(SRow, { className: 'pad-all-sm' },
                    React.createElement(SCol, { center: '', span: 'sm-10 md-7 lg-5 5', className: 'margin-bottom-xl' },
                        React.createElement("div", { className: 'left-col-header font-light' }, "What to expect:"),
                        React.createElement(AccordionRoot, { contents: accordionContent, defaultOpenItem: GUIDED_QUESTIONNAIRE_ACCORDION_ITEM_INDEX, flow: riskAssessmentFlow }),
                        React.createElement("h3", { className: 'alt pad-bottom-sm pad-top-md' }, "Questions?"),
                        discountCode && React.createElement("p", null,
                            React.createElement(ExternalLink, { alwaysOpenInNewTab: true, href: 'https://www.avalara.com/us/en/products/professional-services/sales-tax-risk-assessment.html' }, "Learn more"),
                            " about the Sales Tax Risk Assessment"),
                        React.createElement("p", null,
                            discountCode ? 'Or call ' : '',
                            React.createElement("a", { href: 'tel://+18772243650' }, "1 (877) 224-3650"))),
                    React.createElement(SCol, { center: '', span: 'sm-10 md-7 lg-6 5', offset: 'xl-1 lg-1', className: 'pad-left-none pad-right-none' },
                        React.createElement(CartInfo, null),
                        React.createElement("h1", { className: 'pad-bottom-sm' }, "Start your Sales Tax Risk Assessment"),
                        React.createElement(AccountAndPaymentAccordions, { createAccountOpen: createAccountOpen, isLoggedIn: isLoggedIn, onAccountOrPaymentAccordionToggle: onAccountOrPaymentAccordionToggle, paymentView: 'risk-assessment', accountTitleText: 'Enter your contact info', hidePaymentPage: discountCode != null && discountPercent === 100, showConnectors: showConnectors })))))));
};
export default RiskAssessment;
